import type { AdminWebsiteCreateRequest } from "contracts/api/admin/requests";
import {
  AdminLoginResponseSchema,
  AdminWebsiteCreateResponseSchema,
} from "contracts/api/admin/responses";
import type { BenchmarkUpsertRequest } from "contracts/api/benchmark/requests";
import { BenchmarkResponseSchema } from "contracts/api/benchmark/responses";
import type { MetricCatalogUpdateRequest } from "contracts/api/metric/requests";
import {
  MetricCatalogAdminSchema,
  MetricCatalogListResponseSchema,
} from "contracts/api/metric/responses";
import { request } from "./api-client";

// Admin auth + scan-first website creation + reference-data curation, behind the
// shared-secret gate.
export const adminApi = {
  adminLogin: (password: string) =>
    request("POST", "/api/admin/login", AdminLoginResponseSchema, { password }),
  createWebsite: (input: AdminWebsiteCreateRequest) =>
    request(
      "POST",
      "/api/admin/websites",
      AdminWebsiteCreateResponseSchema,
      input,
    ),
  listMetricCatalog: () =>
    request("GET", "/api/metrics", MetricCatalogListResponseSchema),
  updateMetricCatalog: (metricKey: string, input: MetricCatalogUpdateRequest) =>
    request(
      "PUT",
      `/api/metrics/${metricKey}`,
      MetricCatalogAdminSchema,
      input,
    ),
  readBenchmark: (websiteId: string) =>
    request(
      "GET",
      `/api/websites/${websiteId}/benchmark`,
      BenchmarkResponseSchema,
    ),
  upsertBenchmark: (websiteId: string, input: BenchmarkUpsertRequest) =>
    request(
      "PUT",
      `/api/websites/${websiteId}/benchmark`,
      BenchmarkResponseSchema,
      input,
    ),
};
